import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EntitySchema } from 'src/providers/reports-api';

// ============================================================================
// Types
// ============================================================================

export interface ColumnValueOption {
  label: string;
  value: string;
  count: number;
}

export interface columnValuesDataSource {
  [key: string]: {
    [key: string]: ColumnValueOption[];
  };
}

export interface ReportsState {
  columnValues: columnValuesDataSource;
  schemas: EntitySchema[];
}

// ============================================================================
// Initial State
// ============================================================================

const initialState: ReportsState = {
  columnValues: {},
  schemas: []
};

// ============================================================================
// Slice
// ============================================================================

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setColumnValues: (
      state,
      action: PayloadAction<{
        entityKey: string;
        field: string;
        data: ColumnValueOption[];
      }>
    ) => {
      const { entityKey, field, data } = action.payload;
      if (!state.columnValues[entityKey]) {
        state.columnValues[entityKey] = {};
      }
      state.columnValues[entityKey][field] = data;
    },

    clearColumnValues: (state, action: PayloadAction<string>) => {
      delete state.columnValues[action.payload];
    },

    resetColumnValues: (state) => {
      state.columnValues = {};
    },

    setSchemas: (state, action: PayloadAction<EntitySchema[]>) => {
      state.schemas = action.payload;
    }
  }
});

// ============================================================================
// Exports
// ============================================================================

export const { setColumnValues, clearColumnValues, resetColumnValues, setSchemas } =
  reportsSlice.actions;

export default reportsSlice.reducer;

// ============================================================================
// Selectors
// ============================================================================

export const selectColumnValues = (state: { reports: ReportsState }) => state.reports.columnValues;
export const selectSchemas = (state: { reports: ReportsState }) => state.reports.schemas;
